import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Poly Swan Tech. Tous droits réservés.</p>
      <p>
        <a href="/mentions-legales" className="footer-link">Mentions Légales</a>
      </p>
    </footer>
  );
}

export default Footer;